import React, { Component } from "react";

import "./MenuOptions.scss"

class MenuOptions extends Component {
  render() {
    return (
      <li onClick={(index) => this.props.isClicked(this.props.index)} className={(this.props.currItem == this.props.index ? "active" : "")}>
        {this.props.item.name}
      </li>
    );
  }
}

export default MenuOptions;



// WEBPACK FOOTER //
// ./src/Components/MustKnow/MenuOptions.js